import React, { useState } from 'react';

const ADMIN_API = 'https://zhylytaban.kz/admin/api';
const CHAT_API = 'https://chat.prijutnadejda.ru/api';
const SYSTEM_KEY = 'shelter_chat_sync_2026';

export default function BanNotificationMessage({ message }) {
  const [unbanned, setUnbanned] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hidden, setHidden] = useState(false);

  let data = {};
  try { data = JSON.parse(message.content); } catch(e) {}

  const { username, group, message_text, ai_reason, ban_id } = data;

  async function hideMessage() {
    try {
      await fetch(`${CHAT_API}/antispam/hide/${message.id}`, {
        method: 'POST',
        headers: { 'X-System-Key': SYSTEM_KEY }
      });
    } catch(e) {}
    setHidden(true);
  }

  async function handleUnban() {
    if (!ban_id || loading || unbanned) return;
    setLoading(true);
    try {
      const res = await fetch(`${ADMIN_API}/antispam/telegram/system-unban/${ban_id}`, {
        method: 'POST',
        headers: { 'X-System-Key': SYSTEM_KEY }
      });
      if (res.ok) {
        setUnbanned(true);
        setTimeout(() => hideMessage(), 800);
      } else {
        alert('Ошибка разбана');
      }
    } catch(e) {
      alert('Ошибка сети');
    } finally {
      setLoading(false);
    }
  }

  if (hidden) return null;

  return (
    <div style={{
      background: '#fff3f3',
      border: '1px solid #ffcdd2',
      borderLeft: '4px solid #f44336',
      borderRadius: 8,
      padding: '10px 14px',
      margin: '4px 0',
      maxWidth: 420,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#c62828' }}>
          🛡️ Заблокирован за спам
        </div>
        <button
          onClick={hideMessage}
          title="Скрыть"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 16,
            color: '#aaa',
            padding: '0 2px',
            lineHeight: 1,
          }}
        >✕</button>
      </div>
      <div style={{ fontSize: 13, marginBottom: 2 }}>
        <b>Пользователь:</b> {username || '—'}
      </div>
      <div style={{ fontSize: 13, marginBottom: 6 }}>
        <b>Группа:</b> {group || '—'}
      </div>
      {message_text && message_text !== 'Ручной бан' && (
        <div style={{ marginBottom: 6 }}>
          <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>📝 Текст поста:</div>
          <div style={{
            fontSize: 12,
            color: '#333',
            background: '#fff',
            border: '1px solid #eee',
            borderRadius: 4,
            padding: '6px 8px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            maxHeight: 120,
            overflowY: 'auto',
          }}>
            {message_text}
          </div>
        </div>
      )}
      {ai_reason && (
        <div style={{ marginBottom: 6 }}>
          <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>🤖 Причина:</div>
          <div style={{ fontSize: 12, color: '#555', fontStyle: 'italic' }}>
            {ai_reason}
          </div>
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
        <button
          onClick={handleUnban}
          disabled={loading || unbanned}
          style={{
            padding: '5px 14px',
            fontSize: 12,
            borderRadius: 6,
            border: 'none',
            cursor: unbanned ? 'default' : 'pointer',
            background: unbanned ? '#c8e6c9' : '#ef5350',
            color: unbanned ? '#2e7d32' : '#fff',
            fontWeight: 600,
            transition: 'background 0.2s',
          }}
        >
          {unbanned ? '✓ Разбанен' : loading ? 'Разбаниваю...' : 'Разбанить'}
        </button>
        {!unbanned && (
          <button
            onClick={hideMessage}
            style={{
              padding: '5px 14px',
              fontSize: 12,
              borderRadius: 6,
              border: '1px solid #ddd',
              cursor: 'pointer',
              background: '#f5f5f5',
              color: '#666',
              fontWeight: 500,
            }}
          >
            Скрыть
          </button>
        )}
      </div>
    </div>
  );
}
